module.exports = __webpack_public_path__ + "static/media/ic_biometric_register.466a9423.svg";